module.exports = __webpack_public_path__ + "img/consult_contact_wechat.01e390d0.png";